import { combineActions, handleActions } from 'redux-actions';
import { capabilityUtils } from 'moet-core';
import { email as emailValidator } from '@klarna/mf-validations';

import {
  INIT_APP,
  ON_CHANGE_FORM_VALUE,
  SET_CONFIRMED_COUNTRY_KEY,
  SET_PRODUCTS,
  CAPS,
} from '../constants';

const init = {
  isSent: false,
  isLoading: false,
  isDisabled: false,
  confirmedCountry: '',
  data: {
    country: '',
    platform: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    salesRepId: '',
    sellsSensitiveGoods: null,
    website: '',
    annualRevenue: '',
    fullName: '',
    extraInfo: '',
    referral: undefined,
    utmContent: undefined,
    utmCampaign: undefined,
    utmMedium: undefined,
    utmSource: undefined,
  },
  setupError: null,
};

const capabilityLoadingActionsThatShouldResetErrors = capabilityUtils.getLoadingActions([
  CAPS.SETUP_POST,
]);

export default handleActions(
  {
    [combineActions(...capabilityLoadingActionsThatShouldResetErrors)]: state => ({
      ...state,
      isLoading: true,
      isDisabled: true,
    }),
    [CAPS.SETUP_POST]: (state, { error, payload = {} }) => {
      const { data = {} } = payload;
      return {
        ...state,
        isLoading: false,
        isDisabled: false,
        data: {
          ...state.data,
          ...(error ? { isError: true } : {}),
          isExistingUser: data.isExistingUser || false,
          merchantId: data.merchantId,
          widgetUrl: data.widgetUrl,
        },
        setupError: error ? payload : null,
      };
    },
    [ON_CHANGE_FORM_VALUE]: (state, { payload: { key, value } }) => ({
      ...state,
      data: { ...state.data, [key]: value },
      setupError: null,
    }),
    [INIT_APP]: (state, { payload }) => {
      const { resetData = {}, urlParams = {} } = payload;
      // products params always return an array
      const { products, salesRepId } = urlParams;

      if (products && typeof products === 'string') {
        urlParams.products = products.split(' ');
      }

      try {
        const salesRepEmail = atob(salesRepId).trim();
        // salesRepId might be a base64 encoded email, so we decode it here
        if (salesRepId && !emailValidator.validate(salesRepEmail).error) {
          urlParams.salesRepId = salesRepEmail;
        }
      } catch (error) {
        /* We do nothing, just keep the sales rep id as it's */
      }

      // This is to simulate choosing US from a country dropdown and keep the value stored in the
      // state to be submitted later to the back-end
      if (urlParams.region === 'us') {
        resetData.country = 'us';
      }

      return {
        ...state,
        data: {
          ...state.data,
          ...urlParams,
          ...resetData,
        },
      };
    },
    [SET_CONFIRMED_COUNTRY_KEY]: (state, { payload }) => ({ ...state, confirmedCountry: payload }),
    [SET_PRODUCTS]: (state, { payload }) => ({
      ...state,
      data: { ...state.data, products: payload },
    }),
  },
  init,
);
